export default "__VITE_ASSET__moyUuksy__"